import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const CurrentRole = sessionStorage.getItem('RoleID');
    const CurrenUser = sessionStorage.getItem('UserName');
    if (CurrenUser && CurrentRole) {
      // check if route is restricted by role
      if (route.data.roles && route.data.roles.indexOf(CurrentRole) === -1) {
        // role not authorised so redirect to home page
        this.router.navigate(['/Login']);
        return false;
      }
      // authorised so return true
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/AuthGuard/AuthGuard.Component.ts